import { formatAccessibleDate } from '@/core/utils/date/formatAccessibleDate'

import { useFgtsLoanSimulator } from '../../core/context'
import { makeCurrencyAccessible } from '../../core/utils'
import type { AccessibleHighlightedTextProps as AccessibleTextProps } from '../AccessibleHighlightedText'

interface TextProps extends AccessibleTextProps {}

export const useSimulationResult = () => {
  const { birthDateRef, availableAmountRef, salaryRef, monthsWorkedRef } = useFgtsLoanSimulator()

  const birthDateValue = birthDateRef.current ? birthDateRef.current.value : '0'
  const fgtsValue = availableAmountRef.current ? availableAmountRef.current.value : '0'
  const salaryAmount = salaryRef.current ? salaryRef.current.value : '0'
  const employedTime = monthsWorkedRef.current ? monthsWorkedRef.current.value : '0'

  const birthDateText: TextProps = {
    text: 'Data de nascimento: ',
    highlightedText: birthDateValue,
    accessibleText: `Data de nascimento: ${formatAccessibleDate(birthDateValue)}`,
  }

  const salaryText: TextProps = {
    text: 'Renda Bruta:',
    highlightedText: salaryAmount,
    accessibleText: `Renda bruta: ${makeCurrencyAccessible(salaryAmount)}`,
  }

  const monthLabel =
    monthsWorkedRef.current && Number(monthsWorkedRef.current?.value) > 1 ? 'meses' : 'mês'

  const monthsWorkedText: TextProps = {
    text: 'Tempo empregado:',
    highlightedText: `${employedTime} ${monthLabel}`,
    accessibleText: `Tempo empregado: ${monthsWorkedRef.current?.value} meses`,
  }

  const fgtsText: TextProps = {
    text: 'Valor do saldo de FGTS:',
    highlightedText: fgtsValue,
    accessibleText: `Valor do saldo de  FGTS: ${makeCurrencyAccessible(fgtsValue)}`,
  }

  return { birthDateText, salaryText, monthsWorkedText, fgtsText }
}
